var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',_vm._b({},'v-col',_vm.config.props,false),_vm._l((_vm.config.children),function(componentConfig,index){return _c(_vm.selectComponent(componentConfig),_vm._b({key:index,tag:"component"},'component',_vm.getComponentProps(componentConfig),false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }